import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { CustomerDocumentType } from '@/types';
import { useCreateCustomerDocumentTypeMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface CreateCustomerDocumentTypeProps extends DialogProps {
  onClose(): void;
}

const CreateCustomerDocumentType: React.FC<CreateCustomerDocumentTypeProps> = ({ onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [createCustomerDocumentType, createCustomerDocumentTypeResponse] = useCreateCustomerDocumentTypeMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<CustomerDocumentType>({
    initialValues: {
      name: '',
    },
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(customerDocumentType, { resetForm }) {
      try {
        await createCustomerDocumentType(customerDocumentType).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Добавить документ</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={createCustomerDocumentTypeResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={createCustomerDocumentTypeResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={createCustomerDocumentTypeResponse.isLoading}>
            Добавить
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateCustomerDocumentType;
